// MSAL 弹窗判断：MSAL 打开的登录弹窗会把 window.name 设为 "msal.<guid>"，
// 且 window.opener 指向父窗口。这个环境里不能再调用 acquireToken*，否则会触发
// MSAL 的 block_nested_popups 错误。
export const isMsalPopup = () => {
  return typeof window !== "undefined" &&
    !!window.opener &&
    window.opener !== window &&
    typeof window.name === "string" &&
    window.name.indexOf("msal.") === 0
}
